import React from 'react';

const AttendanceReport = () => {
  return (
    <div>
      AttendanceReport
      AttendanceReport
    </div>
  );
}

export default AttendanceReport;
